export default "__VITE_ASSET__CQQbK66y__"